import * as React from 'react';

const PauseIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 3.5C5.5 3.22386 5.72386 3 6 3H7C7.27614 3 7.5 3.22386 7.5 3.5V12.5C7.5 12.7761 7.27614 13 7 13H6C5.72386 13 5.5 12.7761 5.5 12.5V3.5ZM9.5 3.5C9.5 3.22386 9.72386 3 10 3H11C11.2761 3 11.5 3.22386 11.5 3.5V12.5C11.5 12.7761 11.2761 13 11 13H10C9.72386 13 9.5 12.7761 9.5 12.5V3.5Z"
      fill="currentColor"
    />
  </svg>
);

export default PauseIcon; 